// extracted by mini-css-extract-plugin
export default {"simInHand":"sim-in-hand-module--sim-in-hand--0d69f","actions":"sim-in-hand-module--actions--715d9","darkGreyCard":"sim-in-hand-module--dark-grey-card--07222"};